import * as React from 'react';
import { SVGProps } from 'react';

const SvgDot = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 12a5 5 0 1 1-10.001-.001A5 5 0 0 1 17 12z" />
  </svg>
);

export default SvgDot;
